import type { BaseUser } from '@root/@types/types';

export const getUserDisplayName = (user: BaseUser) => `${user.firstName} ${user.lastName}`;
